import { useEffect, useRef } from "react";
import { ICaptchaProvider, CaptchaProps } from "./ICaptchaProvider";
import { loadTurnstileScript } from "./loadTurnstileScript";

declare global {
  interface Window {
    turnstile?: any;
    _env_?: any;
    env?: any;
  }
}

let lastWidgetId: string | null = null;

const TurnstileComponent: React.FC<CaptchaProps> = ({ onToken }) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!ref.current) return;

    let disposed = false;

    loadTurnstileScript().then(() => {
      if (disposed) return;
      if (!window.turnstile) return;

      lastWidgetId = window.turnstile.render(ref.current!, {
        sitekey: window._env_?.TURNSTILE_SITE_KEY ?? window.env?.TURNSTILE_SITE_KEY,
        theme: "light",
        size: "normal",
        appearance: "always",
        interaction: "always",
        callback: (token: string) => onToken(token),
        "expired-callback": () => onToken(""),
        "error-callback": () => onToken(""),
      });
    });

    return () => {
      disposed = true;
      if (lastWidgetId && window.turnstile) {
        window.turnstile.remove(lastWidgetId);
        lastWidgetId = null;
      }
    };
  }, [onToken]);

  return <div ref={ref} />;
};

export const TurnstileProvider: ICaptchaProvider = {
  Component: TurnstileComponent,
  reset: () => {
    if (lastWidgetId && window.turnstile) {
      window.turnstile.reset(lastWidgetId);
    }
  },
};